<!--primary, accent, or warn -->
<mat-toolbar class="flex justify-between "> <!-- justify-between justify-center -->
  <div>
    @if (homeVisible) {
      <button mat-flat-button color="primary" (click)="setRoot('/')">
        <mat-icon>home</mat-icon>
      </button>
    }
    @if (backVisible) {
      <button mat-flat-button color="accent" (click)="doBack()">回上頁
        <mat-icon>arrow_back</mat-icon>
      </button>
    }
  </div>
  <div>
    <span class="jk-title">{{label()}}</span>
  </div>
  <!-- <div>
    <mat-label style="color:blue; font-size: larger;">{{label()}}</mat-label>
  </div> -->
  <div>
    @if (user1Visible) {
      <button mat-flat-button color="basic" (click)="user1Click()">
        {{user1Text}}
      </button>
    }
    @if (user2Visible) {
      <button mat-flat-button color="basic" (click)="user2Click()">
        {{user2Text}}
      </button>
    }
    @if (user3Visible) {
      <button mat-flat-button color="basic" (click)="user3Click()">
        {{user3Text}}
      </button>
    }
    @if (user4Visible) {
      <button mat-flat-button color="basic" (click)="user4Click()">
        {{user4Text}}
      </button>
    }
    @if (user5Visible) {
      <button mat-flat-button color="basic" (click)="user5Click()">
        {{user5Text}}
      </button>
    }
    <button mat-flat-button [matMenuTriggerFor]="menu" color="primary" aria-label="Example icon-button with a menu">
      <mat-icon>more_vert</mat-icon>
    </button>
  </div>
</mat-toolbar>

<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="menuClick('add')">
    <mat-icon>add</mat-icon>
    <span>新增</span>
  </button>
  <button mat-menu-item (click)="menuClick('search')">
    <mat-icon>search</mat-icon>
    <span>查詢</span>
  </button>
  <button mat-menu-item (click)="menuClick('refresh')">
    <mat-icon>refresh</mat-icon>
    <span>重新整理</span>
  </button>
  <button mat-menu-item (click)="menuClick('arrow_upward')">
    <mat-icon>arrow_upward</mat-icon>
    <span>至頂端</span>
  </button>
</mat-menu>
